import React, { useCallback } from 'react';
import { useShallow } from 'zustand/react/shallow';
import GraphicProductData from '../graphicEditor/GraphicProductData';
import useNodesFeedStore from './stores/useNodesFeedStore';

const selectPanelData = (s) => ({
  product: s.product,
  productFields: s.productFields,
  feedPage: s.feedPage,
  feedPageIndex: s.feedPageIndex,
  productIndex: s.productIndex,
  reloadingProducts: s.reloadingProducts,
  toPrevProduct: s.toPrevProduct,
  toNextProduct: s.toNextProduct,
  toSelectProduct: s.toSelectProduct,
  toFeedPageSelect: s.toFeedPageSelect,
  searchProductById: s.searchProductById,
});

const NodesProductDataPanel = ({ onClose, style }) => {
  const {
    product,
    productFields,
    feedPage,
    feedPageIndex,
    productIndex,
    reloadingProducts,
    toPrevProduct,
    toNextProduct,
    toSelectProduct,
    toFeedPageSelect,
    searchProductById,
  } = useNodesFeedStore(useShallow(selectPanelData));

  const resetProductSearch = useCallback(() => {
    const s = useNodesFeedStore.getState();
    s.clearFeedListQuery();
    void s.loadFeed(s.feedPageIndex);
  }, []);

  return (
    <GraphicProductData
      product={product}
      productFields={productFields}
      feedPage={feedPage}
      feedPageIndex={feedPageIndex}
      productIndex={productIndex}
      reloadingProducts={reloadingProducts}
      searchProductById={searchProductById}
      resetProductSearch={resetProductSearch}
      toPrevProduct={toPrevProduct}
      toNextProduct={toNextProduct}
      toSelectProduct={toSelectProduct}
      toFeedPageSelect={toFeedPageSelect}
      onClose={onClose}
      style={style}
    />
  );
};

export default NodesProductDataPanel;
